// ==============================|| THEME CONFIG  ||============================== //

// Where a signed-in person lands, and where an unknown path goes.
export const HOME_PATH = '/cpv';

const config = {
  defaultPath: HOME_PATH,
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  container: true,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr'
};

export default config;
export const drawerWidth = 260;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
